import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-orange-50 py-16 sm:py-20" aria-labelledby="results-title" data-id="element-152" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-153" data-mp="28ddg15bty3om">
        <h2 id="results-title" className="text-center text-3xl font-extrabold text-green-950 sm:text-4xl" data-id="element-154" data-mp="2d6zu91xn6fmj">
          What educators using this teacher ready say
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-155" data-mp="2m63g2do7194q">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex flex-col rounded-xl border border-stone-200 bg-white p-6 shadow-sm ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-156" data-mp="2r70v4hdwpn20" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-amber-500" aria-hidden="true" data-id="element-157" data-mp="3nfir88ml7vfa" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-stone-600" data-id="element-158" data-mp="3ilem7uwvtxgu">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-stone-100 pt-4" data-id="element-159" data-mp="3dljw3tkxlbwu">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-green-900 text-sm font-extrabold text-amber-400" data-id="element-160" data-mp="38qcwoxyp2tdq">
                  {initials}
                </span>
                <span data-id="element-161" data-mp="58mfv9px717e">
                  <b className="block text-sm text-green-950" data-id="element-162" data-mp="8q6sw2d8jkz">{name}</b>
                  <small className="text-xs text-stone-500" data-id="element-163" data-mp="6x2hnf86bg5">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}